import { NavLink } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import { useAuthState, useAuthDispatch, logout } from "../../context";

export function UnauthenticatedNav() {
  const auth = useAuthState();
  const dispatch = useAuthDispatch();

  const Logout = () => logout(dispatch);

  return (
      <Navbar expand="lg" className="topnav shadow-sm" sticky="top">
        <Container fluid className="px-3 px-lg-4">
          <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center gap-2">
            <img width="210" src="/YTR-infotech.svg" alt="YTR Infotech" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="topnav" />
          <Navbar.Collapse id="topnav" className="justify-content-end">
            <Nav className="align-items-lg-center gap-lg-2">
              <NavLink className="topnav-link" to="/home" activeClassName="active">
                Home
              </NavLink>

              <NavDropdown
                  title={<span className="topnav-dd">Services</span>}
                  id="dd-services"
                  className="topnav-dropdown"
              >
                <div className="topnav-mega">
                  <div className="topnav-mega-col">
                    <div className="topnav-mega-title">Delivery</div>
                    <NavDropdown.Item as={NavLink} to="/services/recruitment-procurement">
                      Recruitment & Procurement
                      <div className="topnav-mega-sub">Talent, staffing, sourcing</div>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/services/application-support">
                      Application Support
                      <div className="topnav-mega-sub">SLA-based operations</div>
                    </NavDropdown.Item>
                  </div>

                  <div className="topnav-mega-col">
                    <div className="topnav-mega-title">Engineering</div>
                    <NavDropdown.Item as={NavLink} to="/services/research-development">
                      Research & Development
                      <div className="topnav-mega-sub">Build, prototype, innovate</div>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/services/infrastructure-support">
                      Infrastructure Support
                      <div className="topnav-mega-sub">Cloud, network, reliability</div>
                    </NavDropdown.Item>
                  </div>
                </div>
              </NavDropdown>

              <NavDropdown
                  title={<span className="topnav-dd">Technologies</span>}
                  id="dd-tech"
                  className="topnav-dropdown"
              >
                <div className="topnav-mega">
                  <div className="topnav-mega-col">
                    <div className="topnav-mega-title">Platforms</div>
                    <NavDropdown.Item as={NavLink} to="/technologies/cloud-solutions">
                      Cloud Solutions
                      <div className="topnav-mega-sub">AWS, Azure, DevOps</div>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/technologies/networking-solutions">
                      Networking Solutions
                      <div className="topnav-mega-sub">Secure connectivity</div>
                    </NavDropdown.Item>
                  </div>

                  <div className="topnav-mega-col">
                    <div className="topnav-mega-title">Data & AI</div>
                    <NavDropdown.Item as={NavLink} to="/technologies/data-analytics">
                      Data Analytics
                      <div className="topnav-mega-sub">Dashboards, BI, insights</div>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/technologies/artificial-intelligence">
                      Artificial Intelligence
                      <div className="topnav-mega-sub">ML, GenAI, automation</div>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/technologies/intelligent-automation">
                      Intelligent Automation
                      <div className="topnav-mega-sub">RPA + workflows</div>
                    </NavDropdown.Item>
                  </div>
                </div>
              </NavDropdown>

              <NavDropdown
                  title={<span className="topnav-dd">Careers</span>}
                  id="dd-careers"
                  className="topnav-dropdown"
              >
                <NavDropdown.Item as={NavLink} to="/careers/jobs">
                  Global Job Openings
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/careers/training">
                  Training
                </NavDropdown.Item>
              </NavDropdown>

              {/* ✅ NEW: Resources (mega menu style) */}
              <NavDropdown
                  title={<span className="topnav-dd">Resources</span>}
                  id="dd-resources"
                  className="topnav-dropdown"
                  align="end"   // ✅ adds right alignment so it stays inside screen
              >
                <div className="topnav-mega">
                  {/* Column 1 */}
                  <div className="topnav-mega-col">
                    <div className="topnav-mega-title">Employee Tools</div>

                    <NavDropdown.Item as={NavLink} to="/timesheets">
                      Timesheets
                      <div className="topnav-mega-sub">Submit weekly hours</div>
                    </NavDropdown.Item>

                    {/* Optional: show manager/admin link only when logged in */}
                    {auth.token && (
                        <NavDropdown.Item as={NavLink} to="/timesheets/manage">
                          Timesheets Admin
                          <div className="topnav-mega-sub">Approve / Reject</div>
                        </NavDropdown.Item>
                    )}
                  </div>

                  {/* Column 2 (placeholders you can change later) */}
                  <div className="topnav-mega-col">
                    <div className="topnav-mega-title">Company</div>

                    <NavDropdown.Item as={NavLink} to="/info">
                      Policies & Info
                      <div className="topnav-mega-sub">Company information</div>
                    </NavDropdown.Item>

                  </div>
                </div>
              </NavDropdown>

              <NavLink className="topnav-link" to="/employees" activeClassName="active">
                Employees
              </NavLink>

              <div className="d-flex align-items-center gap-2 ms-lg-2 mt-3 mt-lg-0">
                {auth.token ? (
                    <Button variant="dark" onClick={Logout} className="topnav-btn">
                      Logout
                    </Button>
                ) : (
                    <Nav.Link
                        as={NavLink}
                        to="/login"
                        className="topnav-btn-login d-flex align-items-center"
                        activeClassName="active"
                    >
                      Login
                    </Nav.Link>
                )}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
  );
}